import { render } from "./CatalogPage.vue?vue&type=template&id=e0970cd4&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=js"
export * from "./CatalogPage.vue?vue&type=script&lang=js"

import "./CatalogPage.vue?vue&type=style&index=0&id=e0970cd4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0970cd4"]])

export default __exports__